import { useMemo } from 'react';
import Table from '@app/pages/stepper/showcase/fragments/table/index';
import Header from '@app/pages/stepper/showcase/fragments/header/index';
import useShowcase from '@app/pages/stepper/showcase/hooks/showcase';

const Showcase = () => {
  const { filteredColumns, filteredRows, isRestoreViewButtonVisible } =
    useShowcase();

  const isValidCandidateList =
    filteredColumns?.length > 0 && filteredRows?.length > 0;

  const isLayoutFull = useMemo(
    () => filteredColumns?.length > 5,
    [filteredColumns?.length],
  );

  const renderTableShadow = () =>
    isLayoutFull && <div className="c-app-showcase__shadow" />;

  return (
    <div data-testid="showcase-page">
      <div className="rev-o-container">
        <div className="rev-o-grid">
          <Header
            isRestoreViewButtonVisible={isRestoreViewButtonVisible}
            isValidCandidateList={isValidCandidateList}
          />
        </div>
      </div>
      {isValidCandidateList && (
        <div
          className={`container${isLayoutFull ? ' container--full' : ''}`}
          data-testid="showcase-table-container"
        >
          <div className="rev-o-grid">
            <div className="rev-o-col-12 u-hidden-large-down">
              <div className="c-app-showcase">
                {renderTableShadow()}
                <Table
                  filteredColumns={filteredColumns}
                  filteredRows={filteredRows}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Showcase;
